import {
  Box,
  Stack,
  IconButton,
  Typography,
  Collapse,
  Divider,
  Grid,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useState } from "react";
import { ReportedDataRow } from "../../../store/slices/contentFeedback/contentFeedbackSlice";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";

type ReportRow = {
  heading?: any;
  row: ReportedDataRow;
  reportid: string;
  content?: any;
  sx?:any
  // defaultOpen?: boolean;
  // dropOpen?(data: boolean): void;
};

function ReportedDetails({
  row,
  heading,
  reportid,
  content,sx
}: // defaultOpen,
// dropOpen,
ReportRow) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // Right side: details
  const details = [
    {
      label: "Reported By",
      value:
        `#${row.reported_by?.id} ${row.reported_by?.full_name} ${row.reported_by?.phone}` ||
        "-",
    },
    { label: "Contents", value: row.reported_contents || "-" },
    { label: "Count", value: row.total_reports },
    {
      label: "Reviewed Before",
      value: row.reviewed_before ? "Yes" : "No",
      color: row.reviewed_before ? "green" : "red",
    },
  ];

  // Left side: hierarchy
  const hierarchyDetails = [
    row.report_source && { label: "Source", value: row.report_source },
    row.goal && {
      label: "Goal",
      value: `${row.goal.name} (#${row.goal.id})`,
    },
    row.section && {
      label: "Section",
      value: `${row.section.name} (#${row.section.id})`,
    },
    row.topic && {
      label: "Topic",
      value: `${row.topic.name} (#${row.topic.id})`,
    },
    row.subtopic && {
      label: "Subtopic",
      value: `${row.subtopic.name} (#${row.subtopic.id})`,
    },
  ].filter(Boolean) as { label: string; value: string }[];

  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState: any) => (
        <Box
          sx={sx?sx:{
            // border: "1px solid #ccc",
            // borderRadius: "8px",
            p: "0 8px",
            color: "#4f4f4f",
          }}
        >
          {/* Row Header */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="body1"
              fontWeight={"bold"}
              color={"rgb(79, 79, 79)"}
              sx={{ minWidth: "fit-content" ,display:"flex",alignItems:"center"}}
            >
              {heading ?? ""} Reported Question #
              {row.question_id ?? row.question ?? ""}
            </Typography>

            {content && content}
            <IconButton
              {...bindTrigger(popupState)}
              sx={{ p: "0", m: "5px" }}
              size="small"
              // onClick={() => {
              //   if (dropOpen) {
              //   dropOpen(!open);
              //   }
              //   setOpen(!open);
              // }}
              // disabled={defaultOpen}
            >
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Stack>

          {/* Collapsible Detailed Info */}
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Grid
              container
              sx={{ width: "100%", boxSizing: "border-box", padding: "10px" }}
              style={{ color: "#4f4f4f" }}
            >
              {/* Left: Hierarchy */}
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight={600} mb="10px">
                  Hierarchy of Reported Question #
                  {row.question_id ?? row.question ?? ""}
                </Typography>
                <Stack spacing={1}>
                  {hierarchyDetails.map((item, idx) => (
                    <Stack key={idx} direction="row" spacing={1}>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        minWidth={90}
                      >
                        {item.label}:
                      </Typography>
                      <Typography variant="body2"
                      sx={{
                          wordBreak: "break-word",
                        }}
                      >{item.value}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Grid>

              {/* Right: Other Details */}
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Report Details #{reportid}
                </Typography>
                <Stack spacing={1}>
                  {details.map((item, idx) => (
                    <Stack key={idx} direction="row" spacing={1}>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        minWidth={110}
                      >
                        {item.label}:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: (item as any).color || "inherit",
                          wordBreak: "break-word",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </Popover>
        </Box>
      )}
    </PopupState>
  );
}

export default ReportedDetails;
